//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ClasslinkActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
import { handleListUserClasses } from 'store/userClasses/thunks';

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------



export const handleUserClassesSync = async (sourceId , tenantId ) => {

	try {
		return await apis.post('classlinkRDS', `/handleUserClasses`, {
			body: {   
			"SourcedId": sourceId, 
			"TenantId": tenantId 
		}
		});

	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'handling user classes sync',
                error,
                module: 'CLASSLINK',
                operation: 'HANDLE_USER_CLASS_STUDENT'
            });
		}
		return error;
	}
};
export const handlesynClassUsers = async (sourceId , tenantId , class_id ) => {

	try {
		return await apis.post('classlinkRDS', `/studentSync`, {
			body: {   
			"SourcedId": sourceId, 
			"TenantId": tenantId ,
			class_id
		}
		});

	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'syncing class users',
                error,
                module: 'CLASSLINK',
                operation: 'SET_CLASS_USER'
            });
		}
		return error;
	}
};
export const handleClassLinksUserInfo = async (sourceId, tenantId) => {

	try {
		return await apis.get('classlinkRDS', `/handleUserById/${sourceId}/${tenantId}`);

	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting class link user info',
                error,
                module: 'CLASSLINK',
                operation: 'GET_CLASS_LESSON_USER_INSTRUCTION'
            });
		}
		return error;
	}
};


export const getClasslinkInformation = async (code) => {
	try {
		return await apis.get("classlinkRDS", `/classlinkInformation/${code}`, {});
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error getting class link information',
				error,
				module: 'CLASSLINK',
				operation: 'GET_CLASS_LINK_INFO'
			});
		}
		return ({ error })
	}
}



export const getClasslinkUserInfo = async (tenantid, id) => {
	try {
		return await apis.get("classlinkRDS", `/getClasslinkUserInfo/${tenantid}/${id}`);
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
				message: 'Error getting class link user info',
				error,
				module: 'CLASSLINK',
				operation: 'GET_CLASS_LINK_USER_INFO'
			});
		}
		return ({ error })
	}
}
export const getClasslinkUserInfoOnOwe = async (tenantid, id) => {
	try {
		return await apis.get("classlinkRDS", `/getClasslinkUserById/${tenantid}/${id}`);
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting class link user info on owe',
                error,
                module: 'CLASSLINK',
                operation: 'GET_CLASS_LESSON_USER_INSTRUCTION_ORGANIZATION_ORGANIZATION'
            });
		}
		return ({ error })
	}
}
export const handleUserByClassLinkName = async (name) => {
	if (typeof name != "string") return [];
	try {
		const firstNamme = name.replace(/\s\s+/g, ' ').split(" ")[0].trim() || '';
		const secondNamme = name.replace(/\s\s+/g, ' ').split(" ")[1]?.trim() ||'';
		const classlinkuser = await apis.get("usersRDS", `/classlinkUserByName/${firstNamme || secondNamme }/${secondNamme || firstNamme}`)
		return classlinkuser;

	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'getting class link user by name',
                error,
                module: 'CLASSLINK',
                operation: 'GET_CLASS_LESSON_USER_BOOK_NOTE'
            });
		}
		return ({ error: true });
	}
}


export const handleListClasslinkKeys = async () => {
	try {
		const data = await apis.get('classlinkRDS', `/list_keys`);
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing class link keys',
                error,
                module: 'CLASSLINK',
                operation: 'LIST_CLASS_LESSON_KEYSTORE'
            });
		}
		return {}
	}
}
export const handleUpdateClasslinkKeys = async (config) => {
	try {
		const data = await apis.post('classlinkRDS', `/update_keys`, {
			body: { config }
		});
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'updating class link keys',
                error,
                module: 'CLASSLINK',
                operation: 'UPDATE_CLASS_LESSON_KEYSTORE'
            });
		}
		return {}
	}
}
export const handleListClasslinkSections = async (sourceId , tenantId ) => {
	try {
		const data = await apis.post('classlinkRDS', `/classlink/sections/list`,{
			body: {   
			"id": sourceId, 
			"tenantId": tenantId 
		}
		});
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing class link sections',
                error,
                module: 'CLASSLINK',
                operation: 'LIST_CLASS_LESSON_STUDENT'
            });
		}
		return {}
	}
}
export const handleSyncClasslinkClass =  (sourceId , tenantId , section , currentUser) => async (dispatch) => {
	try {
		const data = await apis.post('classlinkRDS', `/classlink/sections/create`,{
			body: {   
				id: sourceId, 
				tenantId: tenantId, 
				section
		}
		});
		if(data && data.success){
			await dispatch(handleListUserClasses(currentUser.id));
		 }
		return data;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'syncing class link class',
                error,
                module: 'CLASSLINK',
                operation: 'SET_CLASS_LESSON_CLASS'
            });
		}
		return {}
	}
}